import {
    ORDERS_LIST as CRUD_ACTION_LIST,
    ORDERS_CREATE as CRUD_ACTION_CREATE,
    ORDERS_SHOW as CRUD_ACTION_SHOW,
    ORDERS_UPDATE as CRUD_ACTION_UPDATE,
    ORDERS_DELETE as CRUD_ACTION_DELETE,
    ORDERS_CANCEL as CRUD_ACTION_CANCEL,
    ORDERS_REASSIGN as CRUD_ACTION_REASSIGN,
    ORDERS_MANUAL_ASSIGN as CRUD_ACTION_MANUAL_ASSIGN,
    ORDER_TASKS_UPDATE_STATUS as CRUD_ACTION_UPDATE_TASK,
    ORDERS_CANCELLATION_REASONS_LIST as CRUD_CANCELLATION_REASONS_LIST,
    ORDER_TYPES_LIST as ORDER_TYPES_LIST,
    ORDER_ASSIGNMENT_METHODS_LIST,
    ORDERS_PAYMENT_TYPE_LIST as PAYMENT_TYPE_ACTION_LIST,
    ORDERS_STATUS_LIST as STATUS_ACTION_LIST,
    ORDERS_TASKS_TIMELINES_SHOW as TASK_TIMELINES_CRUD_ACTION_SHOW,
    ORDERS_GIFT_STATUS_LIST,
    ORDERS_TIMELINE_STATUS_LIST,
} from "../actions/orders";
import axioses from "@/axios/config";
import qs from "qs"
const additionalHeaders={
    headers: {
        'Content-Type': 'multipart/form-data'
    }
};
const routePrefix='orders';
const orderTaskTimelineRoutePrefix='tasks';

const state = {};

const getters = {};

const actions = {
  [CRUD_ACTION_LIST]: ({ commit, dispatch }, params) => {
    return new Promise((resolve, reject) => {
      commit('START_LOADING', params.withLoading, { root: true });
      axioses.base
          .get(`/${routePrefix}`,{ params ,paramsSerializer: params => {return qs.stringify(params, { skipNulls: true, indices: false })}})
          .then(response => {
            resolve(response);
            commit('STOP_LOADING', params.withLoading, { root: true });
          })
          .catch(error => {
            commit('STOP_LOADING', params.withLoading, { root: true });
            reject(error);
          });
    });
  },
  [CRUD_ACTION_CREATE]: ({ commit, dispatch }, params) => {
    return new Promise((resolve, reject) => {
      axioses.base
          .post(`/${routePrefix}/create`, params)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
    });
  },
  [CRUD_ACTION_SHOW]: ({ commit, dispatch }, params) => {
    return new Promise((resolve, reject) => {
        commit('START_LOADING', null, { root: true });
        axioses.base
            .get(`/${routePrefix}/${params.id}`)
            .then(response => {
                resolve(response);
                commit('STOP_LOADING', null, { root: true });
            })
            .catch(error => {
                commit('STOP_LOADING', null, { root: true });
                reject(error);
            });
    });
  },
  [CRUD_ACTION_UPDATE]: ({ commit, dispatch }, params) => {
    return new Promise((resolve, reject) => {
        commit('START_LOADING', null, { root: true });
        axioses.base
            .put(`/${routePrefix}/${params.id}`,{...params.data})
            .then(response => {
                resolve(response);
                commit('STOP_LOADING', null, { root: true });
            })
            .catch(error => {
                commit('STOP_LOADING', null, { root: true });
                reject(error);
            });
    });
  },
  [CRUD_ACTION_DELETE]: ({ commit, dispatch }, params) => {
    return new Promise((resolve, reject) => {
        commit('START_LOADING', null, { root: true });
        axioses.base
            .delete(`/${routePrefix}/${params.id}`)
            .then(response => {
                resolve(response);
                commit('STOP_LOADING', null, { root: true });
            })
            .catch(error => {
                commit('STOP_LOADING', null, { root: true });
                reject(error);
            });
    });
  },
  [CRUD_ACTION_CANCEL]: ({ commit, dispatch }, params) => {
    return new Promise((resolve, reject) => {
        commit('START_LOADING', null, { root: true });
        axioses.base
            .patch(`/${routePrefix}/${params.id}/cancel`,{...params.data})
            .then(response => {
                resolve(response);
                commit('STOP_LOADING', null, { root: true });
            })
            .catch(error => {
                commit('STOP_LOADING', null, { root: true });
                reject(error);
            });
    });
  },
  [CRUD_ACTION_REASSIGN]: ({ commit, dispatch }, params) => {
    return new Promise((resolve, reject) => {
        commit('START_LOADING', null, { root: true });
        axioses.base
            .patch(`/${routePrefix}/${params.id}/reassign/${params.captain_id}`)
            .then(response => {
                resolve(response);
                commit('STOP_LOADING', null, { root: true });
            })
            .catch(error => {
                commit('STOP_LOADING', null, { root: true });
                reject(error);
            });
    });
  },
  [CRUD_ACTION_MANUAL_ASSIGN]: ({ commit, dispatch }, params) => {
    return new Promise((resolve, reject) => {
        commit('START_LOADING', null, { root: true });
        axioses.base
            .patch(`/${routePrefix}/${params.id}/manual_assign/${params.captain_id}`)
            .then(response => {
                resolve(response);
                commit('STOP_LOADING', null, { root: true });
            })
            .catch(error => {
                commit('STOP_LOADING', null, { root: true });
                reject(error);
            });
    });
  },
  [CRUD_ACTION_UPDATE_TASK]: ({ commit, dispatch }, params) => {
    return new Promise((resolve, reject) => {
        commit('START_LOADING', null, { root: true });
        let fData=new FormData();
        Object.keys(params).forEach(key=>{
            if(typeof params[key] !== "undefined"  && params[key] !==null){
                fData.append(key,params[key]);
            }
        });
        axioses.base
            .patch(`tasks/${params.id}/COMPLETED`, fData,additionalHeaders)
            .then(response => {
                resolve(response);
                commit('STOP_LOADING', null, { root: true });
            })
            .catch(error => {
                commit('STOP_LOADING', null, { root: true });
                reject(error);
            });
    });
  },
  [CRUD_CANCELLATION_REASONS_LIST]: ({ commit, dispatch }, params) => {
    return new Promise((resolve, reject) => {
        commit('START_LOADING', params.withLoading, { root: true });
        axioses.base
            .get(`/${routePrefix}/cancellation_reasons`,{ params })
            .then(response => {
                resolve(response);
                commit('STOP_LOADING', params.withLoading, { root: true });
            })
            .catch(error => {
                commit('STOP_LOADING', params.withLoading, { root: true });
                reject(error);
            });
    });
  },
  [PAYMENT_TYPE_ACTION_LIST]: ({ commit, dispatch }, params) => {
    return new Promise((resolve, reject) => {
        let response ={
            data: ["CASH_ON_DELIVERY", "PREPAID"]
        };
        resolve(response);
    });
  },
  [STATUS_ACTION_LIST]: ({ commit, dispatch }, params) => {
    return new Promise((resolve, reject) => {
        let response ={
            data: [
                "NOT_ASSIGNED", "ASSIGNED", "COLLECTING_ORDER", "ON_THE_WAY", "DELIVERED", "CANCELED", "FAILED_TO_ASSIGN", "RE_ASSIGNING", "RETURNING", "RETURNED",
                "NEAR_PICK_UP", "AT_PICK_UP", "NEAR_DELIVERY", "AT_DELIVERY", "RECOVERED", 
            ]
        };
        resolve(response);
    });
  },
  [ORDER_TYPES_LIST]: ({ commit, dispatch }, params) => {
        return new Promise((resolve, reject) => {
            axioses.base
                .get(`/${routePrefix}/delivery-types`,{ params ,paramsSerializer: params => {return qs.stringify(params, { skipNulls: true, indices: false })}})
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
        });
    },
  [ORDER_ASSIGNMENT_METHODS_LIST]: ({ commit, dispatch }, params) => {
      return new Promise((resolve, reject) => {
          axioses.base
              .get(`/${routePrefix}/assignment-methods`,{ params ,paramsSerializer: params => {return qs.stringify(params, { skipNulls: true, indices: false })}})
              .then(response => {
                  resolve(response);
              })
              .catch(error => {
                  reject(error);
              });
      });
  },
  [ORDERS_GIFT_STATUS_LIST]: ({ commit, dispatch }, params) => {
      return new Promise((resolve, reject) => {
          axioses.base
              .get(`/${routePrefix}/gift-statuses`,{ params ,paramsSerializer: params => {return qs.stringify(params, { skipNulls: true, indices: false })}})
              .then(response => {
                  resolve(response);
              })
              .catch(error => {
                  reject(error);
              });
      });
  },
  [ORDERS_TIMELINE_STATUS_LIST]: ({ commit, dispatch }, params) => {
      return new Promise((resolve, reject) => {
          axioses.base
              .get(`/${routePrefix}/timeline-statuses`,{ params ,paramsSerializer: params => {return qs.stringify(params, { skipNulls: true, indices: false })}})
              .then(response => {
                  resolve(response);
              })
              .catch(error => {
                  reject(error);
              });
      });
  },
  [TASK_TIMELINES_CRUD_ACTION_SHOW]: ({ commit, dispatch }, params) => {
    return new Promise((resolve, reject) => {
        commit('START_LOADING', null, { root: true });
        axioses.base
            .get(`/${orderTaskTimelineRoutePrefix}/${params.id}/history`,{ params:{...params.data} })
            .then(response => {
                resolve(response);
                commit('STOP_LOADING', null, { root: true });
            })
            .catch(error => {
                commit('STOP_LOADING', null, { root: true });
                reject(error);
            });
    });
  },
};

const mutations = {};

export default {
  state,
  getters,
  actions,
  mutations
};
